import creditAllocation from './creditAllocation';
import distributorAgentWallet from './distributorAgentWallet';
import referralCode from './referralCode';

export default {
  distributorAgentWallet,
  creditAllocation,
  referralCode,
};
